// extracted by mini-css-extract-plugin
module.exports = {"dashMenu":"DashboardMenu_dashMenu__2vlC5","count":"DashboardMenu_count__2ElA6","active":"DashboardMenu_active__3eeOj"};